import React, { useCallback, useContext, useMemo } from 'react';

import { GoogleMap, MarkerClusterer, MarkerF } from '@react-google-maps/api';
import { LocationContext } from '../locationFinder';
import { DEFAULT_MAP_POSITION } from '../../../utils/map';

const containerStyle = {
  width: '100%',
  height: '100%',
};

const Map = ({ mapRef, style }) => {
  const { locations, handleSetActiveLocation } = useContext(LocationContext);

  const handleLoad = useCallback(
    (map) => {
      mapRef.current = map;
      // eslint-disable-next-line no-undef
      const bounds = new google.maps.LatLngBounds();

      if (locations) {
        locations.forEach((location) => {
          bounds.extend(location.position);
        });
      }
      mapRef.current.fitBounds(bounds);
    },
    [mapRef, locations]
  );

  const [retail, cardlock] = useMemo(() => {
    const retail = locations.filter((location) => !location.hasNfn);
    const cardlock = locations.filter((location) => location.hasNfn);
    return [retail, cardlock];
  }, [locations]);

  return (
    <GoogleMap
      ref={mapRef}
      mapContainerStyle={containerStyle}
      mapContainerClassName="map-container"
      center={DEFAULT_MAP_POSITION}
      zoom={6}
      options={{
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
      }}
      onLoad={handleLoad}>
      {retail && (
        <MarkerClusterer
          averageCenter
          gridSize={60}
          options={{
            ignoreHidden: true,
            styles: [
              {
                textColor: '#00539d',
                url: '../../../img/map-icons/cluster2.svg',
                width: 36,
                height: 50,
                anchorText: [-5, 0],
              },
            ],
          }}>
          {(clusterer) =>
            retail.map((location) => (
              <MarkerF
                key={location.Site_ID}
                position={location.position}
                clusterer={clusterer}
                icon="../../../img/map-icons/icon-map-pin-cardlock-um.png"
                onClick={() => {
                  handleSetActiveLocation(location);
                }}
              />
            ))
          }
        </MarkerClusterer>
      )}
      {cardlock && (
        <MarkerClusterer
          averageCenter
          gridSize={60}
          options={{
            ignoreHidden: true,
            styles: [
              {
                textColor: '#00539d',
                url: '../../../img/map-icons/cluster2.svg',
                width: 36,
                height: 50,
                anchorText: [-5, 0],
              },
            ],
          }}>
          {(clusterer) =>
            cardlock.map((location) => (
              <MarkerF
                key={location.Site_ID}
                position={location.position}
                clusterer={clusterer}
                icon="../../../img/map-icons/icon-map-pin-cardlock-um.png"
                onClick={() => {
                  handleSetActiveLocation(location);
                }}
              />
            ))
          }
        </MarkerClusterer>
      )}
    </GoogleMap>
  );
};

export default Map;
